import {
  Backdrop,
  Box,
  Button,
  createTheme,
  Skeleton,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { clippingParents } from "@popperjs/core";
import moment from "moment";
import React, { useMemo } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useImmer } from "use-immer";
import { common_axios } from "../../../App";
import Loader from "../../../components/Loader";
import { dateFormatter } from "../../../helper/helper";
import PieGraph from "../Dashboard/PieGraph";
import Marquee from "react-easy-marquee";
import { useLocation } from "react-router-dom";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DoughnutGraph from "./DoughnutGraph";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import Swal from "sweetalert2";
import ColumnFilter from "../UserManagement/Tables/ColumnFilter";

export default function DashboradTable({
  data111,
  id,
  userGrop,
  notshowpie,
  resetcalnder,
}) {
  const [first, setfirst] = useState([]);
  const [open, setOpen] = useState(false);
  const [status, setstatus] = useState({
    value: "",
    reason: "",
  });
  const [date, setdate] = useState({
    year: new Date().getFullYear(),

    month: moment(new Date()).format("MMMM YYYY"),
  });
  const [newDate, setnewDate] = useState({
    year: moment(date.month, "MMMM-YYYY").year(),
    month: moment(date.month, "MMMM-YYYY").month() + 1,
  });
  const [leaveEntry, setLeaveEntry] = useState(undefined);
  const [leavesbyOther, setleavesbyOther] = useState([]);
  const [NoticePeriod, setNoticePeriod] = useState([]);
  const [propsState, setpropsState] = useState(false);
  const [notice, setNotice] = useState([]);

  const leaveStatus = useRef(null);

  const [data, setData] = useState([]);

  const notices = [
    { id: 1, notice: "Notice 1" },
    { id: 2, notice: "Notice 2" },
    { id: 3, notice: "Notice 3" },
  ];

  // console.log("hhhjjj", NoticePeriod);

  const LeaveStatsuModal = async (data) => {
    await setLeaveEntry(data);
    await leaveStatus.current.click();
  };

  const location = useLocation();

  const userModal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const valueButton = useSelector((state) => state.buttonSlice.button);

  const viewAttendance = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(`/attendance/viewAttendance`, {
        userId: localStorage.getItem("UserId"),
        year: moment(date.month, "MMMM-YYYY").year(),
        month: moment(date.month, "MMMM-YYYY").month() + 1,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        const startOfMonth = moment(
          res.data?.attendanceEntity?.[0]?.date,
          "YYYY-MM-DD"
        )
          .startOf("month")
          .format("d");
        var poster =
          "Day in number[0,1,2,3,4,5,6]: " +
          moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD").format(
            "d"
          ) +
          " " +
          moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
            .add(-1, "M")
            .format("DD-MM-YYYY") +
          " " +
          moment(
            moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD").add(
              -1,
              "M"
            )
          ).daysInMonth() +
          " next" +
          moment(
            moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
          ).daysInMonth();

        let arr = [];

        for (let index = 0; index < startOfMonth; index++) {
          let obj = {
            date:
              Number(
                moment(
                  moment(
                    res.data?.attendanceEntity?.[0]?.date,
                    "YYYY-MM-DD"
                  ).add(-1, "M")
                ).daysInMonth()
              ) - index,
            status: 99,
          };

          arr.push(obj);
        }

        let arrr = [];

        for (
          let index = 0;
          index <
          moment(
            moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
          ).daysInMonth() -
            res.data?.attendanceEntity?.length;
          index++
        ) {
          // console.log(index);
          // const element = array[index];

          let obj = {
            date:
              Number(
                moment(
                  moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
                ).daysInMonth()
              ) - index,
            status: 99,
          };

          // console.log(obj);

          arrr.push(obj);
        }

        let arry = [];
        let datee = moment(
          moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
        ).daysInMonth();

        let obj = { id: 1, date: "03-02-2023" };

        arry.push(obj);

        // console.log(arry);

        // console.log(datee);

        // console.log({ poster, arr }, arr.reverse(), [...arr].reverse());

        // console.log("IIIIIIIIIII", arrr, [...arrr].reverse());

        const reversedArray = [...arrr].reverse();

        let arrr2 = [];

        for (let index = 0; index < datee; index++) {
          let obj = {
            date: moment(
              `${moment(
                res.data?.attendanceEntity?.[0]?.date,
                "YYYY-MM-DD"
              ).year()}-${
                moment(
                  res.data?.attendanceEntity?.[0]?.date,
                  "YYYY-MM-DD"
                ).month() + 1
              }-${index + 1}`
            ).format("YYYY-MM-DD"),
            status: 98,
          };

          arrr2.push(obj);
        }

        let arrr3 = [];

        for (let index = 0; index < arrr2.length; index++) {
          const element = arrr2[index];

          for (
            let index1 = 0;
            index1 < res.data?.attendanceEntity?.length;
            index1++
          ) {
            const element1 = res.data?.attendanceEntity?.[index1];

            // console.log(
            //   "PPPPPP",
            //   element.date,
            //   element1.date,
            //   moment(element.date).isSame(element1.date)
            // );

            // if (moment(element.date).isSame(element1.date)) {
            //   arrr3.push(element1);
            // } else {
            //   arrr3.push(element);
            // }

            if (
              moment(element.date, "YYYY-MM-DD").isSame(
                element1.date,
                "YYYY-MM-DD"
              )
            ) {
              arrr2[index] = element1;
            }
          }
        }

        // console.log("OOOOOOOOOO", arrr2);

        // console.log(
        //   "QQQQQQQQQ",
        //   arrr2,
        //   moment(res.data?.attendanceEntity?.[0]?.date).month(),
        //   moment(res.data?.attendanceEntity?.[0]?.date).year()
        // );

        setfirst([...arr, ...arrr2]);
        // setfirst([...arr, ...res.data.attendanceEntity, ...reversedArray]);
        setOpen(false);
      } else if (res.data.statusDescriptions.statusCode == 201) {
        setfirst([]);
        setOpen(false);
        await toast.error(res.data.statusDescriptions.statusDescription, {
          theme: "colored",
        });
      } else {
        setfirst([]);
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      await toast.error("Something went Wrong !", {
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    if (!id) {
      viewAttendance();
    }
  }, [valueButton, date.month]);

  // console.log(
  //   moment(date.month, "MMMM-YYYY").year(),
  //   moment(date.month, "MMMM-YYYY").month() + 1
  // );

  const userModalgroup = JSON.parse(
    localStorage.getItem("usermodal")
  )?.userGroups;

  // const viewAttendanceeemp = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`/attendance/viewAttendance`, {
  //       userId: id,
  //       year: moment(date.month, "MMMM-YYYY")?.year(),
  //       month: moment(date.month, "MMMM-YYYY")?.month() + 1,
  //     });

  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       setOpen(false);
  //       const startOfMonth = moment(
  //         res.data?.attendanceEntity?.[0]?.date,
  //         "YYYY-MM-DD"
  //       )
  //         .startOf("month")
  //         .format("d");

  //       // console.log({ startOfMonth });

  //       var poster =
  //         "Day in number[0,1,2,3,4,5,6]: " +
  //         moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD").format(
  //           "d"
  //         ) +
  //         " " +
  //         moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
  //           .add(-1, "M")
  //           .format("DD-MM-YYYY") +
  //         " " +
  //         moment(
  //           moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD").add(
  //             -1,
  //             "M"
  //           )
  //         ).daysInMonth() +
  //         " next" +
  //         moment(
  //           moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
  //         ).daysInMonth();

  //       let arr = [];

  //       // moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD").format(
  //       //   "d"
  //       // );

  //       for (let index = 0; index < startOfMonth; index++) {
  //         let obj = {
  //           date:
  //             Number(
  //               moment(
  //                 moment(
  //                   res.data?.attendanceEntity?.[0]?.date,
  //                   "YYYY-MM-DD"
  //                 ).add(-1, "M")
  //               ).daysInMonth()
  //             ) - index,
  //           status: 99,
  //         };

  //         arr.push(obj);
  //       }

  //       let arrr = [];

  //       for (
  //         let index = 0;
  //         index <
  //         moment(
  //           moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
  //         ).daysInMonth() -
  //           res.data?.attendanceEntity?.length;
  //         index++
  //       ) {
  //         // console.log(index);
  //         // const element = array[index];

  //         let obj = {
  //           date:
  //             Number(
  //               moment(
  //                 moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
  //               ).daysInMonth()
  //             ) - index,
  //           status: 99,
  //         };

  //         // console.log(obj);

  //         arrr.push(obj);
  //       }

  //       let arry = [];
  //       let datee = moment(
  //         moment(res.data?.attendanceEntity?.[0]?.date, "YYYY-MM-DD")
  //       ).daysInMonth();

  //       let obj = { id: 1, date: "03-02-2023" };

  //       arry.push(obj);

  //       // console.log(arry);

  //       // console.log(datee);

  //       // console.log({ poster, arr }, arr.reverse(), [...arr].reverse());

  //       // console.log("IIIIIIIIIII", arrr, [...arrr].reverse());

  //       const reversedArray = [...arrr].reverse();

  //       let arrr2 = [];

  //       for (let index = 0; index < datee; index++) {
  //         let obj = {
  //           date: moment(
  //             `${moment(
  //               res.data?.attendanceEntity?.[0]?.date,
  //               "YYYY-MM-DD"
  //             ).year()}-${
  //               moment(
  //                 res.data?.attendanceEntity?.[0]?.date,
  //                 "YYYY-MM-DD"
  //               ).month() + 1
  //             }-${index + 1}`
  //           ).format("YYYY-MM-DD"),
  //           status: 98,
  //         };

  //         arrr2.push(obj);
  //       }

  //       let arrr3 = [];

  //       for (let index = 0; index < arrr2.length; index++) {
  //         const element = arrr2[index];

  //         for (
  //           let index1 = 0;
  //           index1 < res.data?.attendanceEntity?.length;
  //           index1++
  //         ) {
  //           const element1 = res.data?.attendanceEntity?.[index1];

  //           // console.log(
  //           //   "PPPPPP",
  //           //   element.date,
  //           //   element1.date,
  //           //   moment(element.date).isSame(element1.date)
  //           // );

  //           // if (moment(element.date).isSame(element1.date)) {
  //           //   arrr3.push(element1);
  //           // } else {
  //           //   arrr3.push(element);
  //           // }

  //           if (
  //             moment(element.date, "YYYY-MM-DD").isSame(
  //               element1.date,
  //               "YYYY-MM-DD"
  //             )
  //           ) {
  //             arrr2[index] = element1;
  //           }
  //         }
  //       }

  //       // console.log("OOOOOOOOOO", arrr2);

  //       // console.log(
  //       //   "QQQQQQQQQ",
  //       //   arrr2,
  //       //   moment(res.data?.attendanceEntity?.[0]?.date).month(),
  //       //   moment(res.data?.attendanceEntity?.[0]?.date).year()
  //       // );

  //       setfirst([...arr, ...arrr2]);
  //       // setfirst([...arr, ...res.data.attendanceEntity, ...reversedArray]);
  //       setOpen(false);
  //     } else if (res.data.statusDescriptions.statusCode == 201) {
  //       setfirst([]);
  //       setOpen(false);
  //       await toast.error(res.data.statusDescriptions.statusDescription, {
  //         theme: "colored",
  //       });
  //     } else {
  //       setfirst([]);
  //       setOpen(false);
  //       // await toast.error(res.data.statusDescriptions.statusDescription, {
  //       //   theme: "colored",
  //       // });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpen(false);
  //     await toast.error("Something went Wrong !", {
  //       theme: "colored",
  //     });
  //   }
  // };

  // useEffect(() => {
  //   if (id) {
  //     viewAttendanceeemp();
  //   }
  // }, [id, date.month]);

  // const leavesByOther = async (dataa1) => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(
  //       `attendance/leavesByOther?userGroup=${userGrop}`
  //     );

  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       await setOpen(false);

  //       let leavearr = [];
  //       for (let i = 0; i < res.data.attendanceDetailsModels.length; i++) {
  //         const ele = res.data.attendanceDetailsModels[i];

  //         if (dataa1?.status != ele?.status) {
  //           leavearr.push(ele);
  //         }
  //       }

  //       await setleavesbyOther(leavearr);
  //     } else {
  //       await setOpen(false);
  //       await toast.error(res.data.statusDescriptions.statusDescription);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     await setOpen(false);
  //     await toast.error("Something Went Wrong ! Please Check your NetWork");
  //   }
  // };
  // useEffect(() => {
  //   if (userGrop) {
  //     leavesByOther();
  //   }
  // }, []);

  const modalClosechange = useRef(null);

  // const markAttendanceEmpByCsm = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`attendance/markAttendanceEmpByCsm`, {
  //       userId: leaveEntry?.userId,
  //       status: status.value,
  //       fromDate: moment(leaveEntry?.date, "YYYY-MM-DD").format("YYYY-MM-DD"),
  //       toDate: "",
  //       reason: status?.reason,
  //       numberOfDays: "",
  //       userGroup: userModalgroup,
  //       userName: localStorage.getItem("usernamedisplayed"),
  //     });

  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       await setOpen(false);
  //       await viewAttendanceeemp();
  //       await setpropsState(true);
  //       await modalClosechange.current.click();
  //       await toast.success(res.data.statusDescriptions.statusDescription, {
  //         theme: "colored",
  //       });
  //     } else {
  //       await setOpen(false);
  //       await modalClosechange.current.click();
  //       await toast.error(res.data.statusDescriptions.statusDescription, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     await setOpen(false);
  //     await modalClosechange.current.click();
  //     await toast.error("Something Went Wrong ! Please Check your NetWork", {
  //       theme: "colored",
  //     });
  //   }
  // };

  // const MapRows = (dataa, index) => {
  //   // console.log(dataa, dataa.status == 2 && dataa.isApproved == null);
  //   var now = moment();
  //   var difff = Math.ceil(now.diff(dataa?.date, "days", true));
  //   return (
  //     <>
  //       <td style={{ border: "1px solid black", height: "90px" }}>
  //         <p class="count">
  //           {dataa?.status != 99
  //             ? moment(dataa?.date, "YYYY-MM-DD").format("DD")
  //             : null}
  //         </p>

  //         {dataa.status != 99 ? (
  //           <p
  //             onClick={() => {
  //               var now = moment();
  //               var difff = Math.ceil(now.diff(dataa?.date, "days", true));

  //               if (
  //                 JSON.parse(localStorage.getItem("Sidebaritems"))?.name !=
  //                 "Employee"
  //               ) {
  //                 if (
  //                   (difff == 1 || difff == 2 || difff == 3) &&
  //                   location?.pathname == "/dashboard/EmployeeAttendance"
  //                 ) {
  //                   setLeaveEntry(dataa);
  //                   LeaveStatsuModal(dataa);
  //                   leavesByOther(dataa);
  //                 }
  //               }
  //             }}
  //             style={
  //               (difff == 1 || difff == 2 || difff == 3) &&
  //               location?.pathname == "/dashboard/EmployeeAttendance" &&
  //               JSON.parse(localStorage.getItem("Sidebaritems"))?.name !=
  //                 "Employee"
  //                 ? { cursor: "pointer" }
  //                 : {
  //                     cursor: "",
  //                   }
  //             }
  //             class={
  //               (dataa.status == 1 && dataa.isApproved == null) ||
  //               (dataa.status == 1 && dataa.isApproved == 1) ||
  //               (dataa.isApproved == 0 && dataa.status == 1)
  //                 ? "content1"
  //                 : dataa.status == 2 && dataa.isApproved == 1
  //                 ? "contentcasual"
  //                 : (dataa.status == 2 && dataa.isApproved == 0) ||
  //                   (dataa.status == 2 && dataa.isApproved == null)
  //                 ? "contentcasual"
  //                 : dataa.status == 0
  //                 ? "contentabsent"
  //                 : (dataa.status == 3 && dataa.isApproved == 0) ||
  //                   (dataa.status == 3 && dataa.isApproved == null)
  //                 ? "contentweekly"
  //                 : dataa.status == 3 && dataa.isApproved == 1
  //                 ? "contentweekly"
  //                 : (dataa.status == 5 && dataa.isApproved == 0) ||
  //                   (dataa.status == 5 && dataa.isApproved == null)
  //                 ? "contentShortleave"
  //                 : dataa.status == 5 && dataa.isApproved == 1
  //                 ? "contentShortleave"
  //                 : dataa.status == 6 && dataa.isApproved == 0
  //                 ? "contentworkfromhome"
  //                 : dataa.status == 98
  //                 ? "contentnone"
  //                 : "contentweekly"
  //             }
  //           >
  //             <span>
  //               {dataa.status == 1
  //                 ? "Present"
  //                 : (dataa.status == 2 && dataa.isApproved == 0) ||
  //                   (dataa.status == 2 && dataa.isApproved == null)
  //                 ? "Pending(CL)"
  //                 : dataa.status == 2 && dataa.isApproved == 1
  //                 ? "Casual Leave"
  //                 : dataa.status == 0
  //                 ? "Absent"
  //                 : (dataa.status == 3 && dataa.isApproved == 0) ||
  //                   (dataa.status == 3 && dataa.isApproved == null)
  //                 ? "Pending(OO)"
  //                 : dataa.status == 3 && dataa.isApproved == 1
  //                 ? "Optional Off"
  //                 : dataa.status == 0
  //                 ? "Absent"
  //                 : (dataa.status == 5 && dataa.isApproved == 0) ||
  //                   (dataa.status == 5 && dataa.isApproved == null)
  //                 ? "Pending(SL)"
  //                 : dataa.status == 5 && dataa.isApproved == 1
  //                 ? "Short Leave"
  //                 : dataa.status == 6 && dataa.isApproved == 0
  //                 ? "WFO"
  //                 : dataa.status == 98
  //                 ? ""
  //                 : null}
  //             </span>
  //             <br />

  //             {/* <spam> {moment(dataa.date).format("DD-MMM-YYYY")}</spam> */}
  //           </p>
  //         ) : null}
  //       </td>
  //     </>
  //   );
  // };
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const fetchSummary = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`summary/allSummary`);

      if (res.data.responseStatus.statusCode == 200) {
        setOpen(false);

        // Create a new object with only the specified keys

        setData(res.data?.list);
        setNotice(res.data?.notice);
        localStorage.setItem("lentgth", res.data?.list?.length);
        // setcontent({
        //   ...content,
        //   currentPage: res.data?.response?.currentPage,
        //   totalItemss: res.data?.response?.totalItems,
        //   totalPagess: res.data?.response?.totalPages,
        // });
        // await setnotdatafound(true);
      } else if (res.data.responseStatus.statusCode == 150) {
        setOpen(false);
        setData([]);
      } else {
        setOpen(false);

        // markAttendacne();
        // await setTimeout(async () => {
        //   await toast.error(res.data.statusDescription.statusDescription, {
        //     theme: "colored",
        //   });
        // }, 100);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await setTimeout(async () => {
        // await toast.error("Something went wrong !! Please check your network", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };

  console.log(data, "data is here");

  useEffect(() => {
    fetchSummary();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },
      {
        Header: "Property Name",

        accessor: "propertyName",
      },
      {
        Header: "Total Rooms",

        accessor: "rooms",
      },
      {
        Header: "Total Beds (In. Warden)",

        accessor: "totalBedsInclWarden",
      },
      {
        Header: "Total Beds (Ex. Warden) ",

        accessor: "totalBeds",
      },
      {
        Header: "Employees Occ.",

        accessor: "occupied",
      },
      {
        Header: "Available Beds",

        accessor: "available",
      },
    ],
    []
  );
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: { pageSize: 20 },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  // const noticeBoardApi = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(
  //       `attendance/noticeBoard?userGroup=${userModal}`
  //     );

  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       setOpen(false);
  //       setNoticePeriod(res.data.noticeBoardModel);
  //     } else if (res.data.statusDescriptions.statusCode == 201) {
  //       // let obj = { notice: "No Notice Available" };

  //       // setNoticePeriod([obj]);
  //       setOpen(false);

  //       // await toast.error(res.data.statusDescriptions.statusDescription, {
  //       //   theme: "colored",
  //       // });
  //     } else {
  //       setOpen(false);
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //     setOpen(false);
  //     await toast.error("Something Went Wrong ! Please check your network", {
  //       theme: "colored",
  //     });
  //   }
  // };

  // useEffect(() => {
  //   if (userModal != undefined) {
  //     noticeBoardApi();
  //   }
  // }, []);

  return (
    <>
      {leaveEntry != undefined ? (
        <>
          <button
            ref={leaveStatus}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop18"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop18"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Change Status
                  </h5>
                  <button
                    type="button"
                    ref={modalClosechange}
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setstatus({
                        value: "",
                        reason: "",
                      });
                    }}
                  ></button>
                </div>
                <form onSubmit={""}>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <div className="row ">
                        <div
                          className=""
                          style={{
                            display: "grid",
                            gridTemplateColumns: "auto auto",
                            justifyContent: "left",
                          }}
                        >
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                            style={{ marginTop: "0.5rem", fontWeight: "700" }}
                          >
                            Change Status To:
                          </label>
                          <select
                            required
                            className="form-select"
                            style={{ marginLeft: "4rem" }}
                            value={status?.value}
                            onChange={(e) => {
                              setstatus({
                                ...status,
                                value: e.target.value,
                              });
                            }}
                          >
                            <option value="">Please Select :-</option>
                            {/* {leavesbyOther?.map((er) => {
                              return (
                                <option value={er?.status}>{er?.name}</option>
                              );
                            })} */}
                          </select>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bold"
                        >
                          Reason For Updation:(Max Limit :-100 characters)
                        </label>
                        <div className="col-md-12">
                          <textarea
                            style={{
                              height: "70px",
                              maxHeight: "150px",
                              minHeight: "60px",
                              width: "400px",
                              maxWidth: "100%",
                              minWidth: "100%",
                              padding: "8px",
                            }}
                            maxlength="100"
                            placeholder="Reason for Updation"
                            value={status?.reason}
                            required
                            // onChange={handleChangetext}
                            onChange={(e) => {
                              setstatus({
                                ...status,
                                reason: e.target.value,
                              });
                            }}
                            class="form-control"
                            id="exampleFormControlTextarea1"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </ThemeProvider>
                  {/* <div className="modal-footer"> */}
                  <div className="px-2 pb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <Button
                        data-bs-dismiss="modal"
                        sx={{ marginLeft: "10px", background: "#4C4234" }}
                        type="reset"
                        variant="contained"
                        onClick={() => {
                          setstatus({
                            value: "",
                            reason: "",
                          });
                        }}
                        endIcon={<CancelIcon />}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ background: "#4CAF50" }}
                        endIcon={<ChangeCircleIcon />}
                      >
                        Change
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      ) : null}

      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <Loader />
      </Backdrop>

      <h4 className="text-center"></h4>
      <div className="row" id="atd_tggl">
        <div className="col-1 col_0">
          <div
            className="d-flex justify-content-center align-items-center"
            id="div_icon"
          >
            {/* {moment(date.month, "MMM-YYYY").format("MMMM YYYY") !=
        moment("01-01-2023", "DD-MM-YYYY").format("MMMM YYYY") ? ( */}
            {/* <>
              <i
                class="fas fa-arrow-circle-left"
                onClick={() => {
                  setdate({
                    ...date,
                    month: moment(date.month, "MMMM-YYYY")
                      .add(-1, "months")
                      .format("MMMM YYYY"),
                  });
                }}
              ></i>
              <span className="ms-2">Prev</span>
            </> */}
            {/* ) : null} */}
            {/* <h6 class="super text-center p-0 mx_5">{date.month}</h6>  */}
            {/* <h3 class="super text-center p-0 mx_5">
              Master Sheet of Hostel Occupancy Data
            </h3> */}
            {/* {moment(date.month, "MMMM-YYYY").month() + 1 ==
            new Date().getMonth() + 1 ? null : (
              <>
                <i
                  class="fas fa-arrow-circle-right"
                  onClick={() => {
                    setdate({
                      ...date,
                      month: moment(date.month, "MMMM-YYYY")
                        .add(1, "months")
                        .format("MMMM YYYY"),
                    });
                  }}
                ></i>
                <span className="ms-2">Next</span>
              </>
            )} */}
          </div>
        </div>
      </div>
      <div class="row mt-3" id="atedance_pie">
        {/* Dasboard attendace portal */}
        {/* <div class="table-responsive"> */}
        {/* <div className="col-1 col_0">
          <div
            className="table_Div w-100 h-100 d-flex flex-column p-1"
            style={{
              paddingRight: "1rem",
              overflow: "auto",
            }}
          >
            {first && first?.length > 0 ? (
              <table className="w-100 my-auto">
                <tr style={{ border: "1px solid black" }}>
                  <th class="text-center">Sun</th>
                  <th class="text-center">Mon</th>
                  <th class="text-center">Tue</th>
                  <th class="text-center">Wed</th>
                  <th class="text-center">Thu</th>
                  <th class="text-center">Fri</th>
                  <th class="text-center">Sat</th>
                </tr>

                <tr
                  class="content_main_div"
                  style={{ border: "0px solid black" }}
                >
                  {first?.map((dataa, index) => {
                    if (index > -1 && index < 7) {
                      return <>{MapRows(dataa, index)}</>;
                    }
                  })}
                </tr>

                <tr
                  class="content_main_div"
                  style={{ border: "0px solid black" }}
                >
                  {first?.map((dataa, index) => {
                    if (index > 6 && index < 14) {
                      return <>{MapRows(dataa, index)}</>;
                    }
                  })}
                </tr>
                <tr
                  class="content_main_div"
                  style={{ border: "0px solid black" }}
                >
                  {first?.map((dataa, index) => {
                    if (index > 13 && index < 21) {
                      return <>{MapRows(dataa, index)}</>;
                    }
                  })}
                </tr>
                <tr
                  class="content_main_div"
                  style={{ border: "0px solid black" }}
                >
                  {first?.map((dataa, index) => {
                    if (index > 20 && index < 28) {
                      return <>{MapRows(dataa, index)}</>;
                    }
                  })}
                </tr>
                <tr
                  class="content_main_div"
                  style={{ border: "0px solid black" }}
                >
                  {first?.map((dataa, index) => {
                    if (index > 27 && index < 31) {
                      return <>{MapRows(dataa, index)}</>;
                    }
                  })}
                </tr>
              </table>
            ) : (
              <div className="text-center m-auto">
                <h5>No Attendance Found For This Month</h5>
              </div>
            )}
          </div>
        </div> */}
        {/* Dasboard attendace portal */}

        {/* Table for tata prdocut */}
        <div className="col-1 col_0">
          <div
            className="table_Div w-100 h-100 d-flex flex-column p-1 table-responsive"
            style={{
              paddingRight: "1rem",
              overflow: "auto",
            }}
          >
            <div style={{ margin: "90px 0 auto" }}>
              <h4 class="super text-center p-0 mx_5">
                Master Sheet of Hostel Occupancy Data
              </h4>
              {data.length > 0 ? (
                <div className="card-body p-4 ">
                  <div className="d-flex justify-content-between my-3">
                    {/* {searchIcon == true && ( */}
                    {/* <select
                    value={5}
                    className="dropdown d-none"
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                    }}
                  > */}
                    {/* {[10, 25, 50].map((value, i) => {
                      return (
                        <option
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                          value={value}
                          key={value}
                        >
                          {" "}
                          Show {value}
                        </option>
                      );
                    })} */}
                    {/* </select> */}
                    {/* )} */}

                    <div>
                      {/* {allColumns.map((column) => {
                  return (
                    <div key={column.id}>
                      <label>
                        <input
                          type="checkbox"
                          {...column.getToggleHiddenProps()}
                        />
                        {column.Header}
                      </label>
                    </div>
                  );
                })} */}
                    </div>
                    {/* {searchIcon == true && ( */}
                    {/* <TextField
                    className="ms-4 "
                    sx={{
                      borderRadius: "4px",
                    }}
                    type="text"
                    label="Search"
                    name="Search"
                    variant="outlined"
                    // value={number}
                    size="small"
                    value={globalSearchValue || ""}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setGlobalSearchValue(e.target.value);
                    }}
                  /> */}
                    {/* )} */}
                  </div>

                  <div className="text-end">
                    {/* {selectedFlatRows.length > 0 && (
                  <button
                    onClick={deletUser}
                    className="btn bg-gradient-primary m-0"
                  >
                    Delete Users
                  </button>
                )} */}

                    {/* <button onClick={changeOrder}>Change Order</button> */}
                  </div>
                  <div className="table-responsive">
                    <table
                      {...getTableProps()}
                      id="example"
                      className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                      // className=" table table-responsive table-striped table-bordered dataTable mt-3"
                    >
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className="text-left width_2"
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>

                                {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                console.log({ cell });
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    className="text-center"
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                      {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      {/* <span>
                      Page:
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </span> */}
                    </div>

                    {/* <div id="Nikhil">
                    <button
                      className="btn btn_primary m-0 ms-2"
                      type="button"
                      style={{
                        background: "#4C4234",
                      }}
                      disabled={!canPreviousPage}
                      onClick={() => {
                        previousPage();
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary m-0 ms-2"
                      type="button"
                      style={{
                        background: "#F67503",
                      }}
                      disabled={!canNextPage}
                      onClick={() => {
                        nextPage();
                      }}
                    >
                      Next
                    </button>
                  </div> */}
                    {/* <div className="text-end mt-2">
                  <p className="link-info" style={{ fontSize: "12px" }}>
                    {" "}
                    List of Accounts. Wannt to Add Account !!
                  </p>
                  <Link
                    to="/dashboard/AddAccount"
                    style={{ color: "#63B7E6", marginLeft: "30px" }}
                  >
                    <button className="btn btn-danger">Click here !!!</button>
                  </Link>
                </div> */}
                  </div>
                </div>
              ) : (
                <div className="card-body">
                  <div>
                    <h5 style={{ textAlign: "center" }}>No Data Available</h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Table for tata prdocut */}
        <div className="col-1 col_1">
          {location?.pathname != "/dashboard/EmployeeRecord" ? (
            // &&
            // notshowpie == true ?
            <div className="pie_Div h-100 d-flex flex-column mt_13">
              {/* <div
                className="h-100 h_480 d-flex px_x"
                style={{
                  border: "1px solid black",
                  // height: "100%",
                  padding: "0rem 1rem",
                }}
              >
                <PieGraph
                  data={date.year}
                  dateee={date.month}
                  empId={id}
                  defineSt={propsState}
                />
               
              </div> */}
              <div
                className="w-100 h-100 h_480 d-flex px_x py-2"
                style={{
                  border: "1px solid #6c757d",
                  // borderRadius: "10px",
                  // height: "100%",
                  padding: "0rem 1rem",
                  height: "300px",
                  width: "300px",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      alignItems: "center",
                      display: "grid",
                      justifyContent: "center",
                      alignContent: "center",
                      // padding: "10px",
                    }}
                  >
                    <h4 style={{ fontSize: "18px" }}>- Summary -</h4>
                  </div>

                  {/* <PieGraph
                    data={date.year}
                    dateee={date.month}
                    empId={id}
                    defineSt={propsState}
                  /> */}

                  <PieGraph dateee={data} />
                </div>
              </div>
              <div
                id="notice"
                className="h-50 d-flex flex-column mt_13"
                style={{
                  border: "1px solid #6c757d",
                  padding: "0rem 1rem",
                  whiteSpace: "break-spaces",
                  marginTop: "5px",
                }}
              >
                <h3
                  className="badge rounded-pill bg-light mt-n3 ms-2 align-self-start mb-3"
                  style={{
                    border: "1px solid black",
                    color: "black",
                    marginBottom: "20px",
                  }}
                >
                  Notice
                </h3>
                {/* <marquee width="60%" direction="up" height="100px">
                  hhhh
                </marquee> */}
                {/* <div key={notices.map((notice) => notice.id).join("-")}>
                  <Marquee
                    axis="Y"
                    height="220px"
                    width="100%"
                    align="start"
                    pauseOnHover={true}
                    reverse={true}
                    duration={5000}
                  >
                    {notices.map((notice) => (
                      <a
                        key={notice.id}
                        className="my-2"
                        href={notice.notice}
                        style={{
                          color: "#0072E5",
                          textDecoration: "underline",
                        }}
                        target="_blank"
                      >
                        {notice.notice}
                      </a>
                    ))}
                  </Marquee>
                </div> */}
                {notice.length > 0 ? (
                  <Marquee
                    duration={10000}
                    // background="#00DEFB"

                    height="220px"
                    width="100%"
                    // width="200px"
                    axis="Y"
                    align="start"
                    pauseOnHover={true}
                    reverse={true}
                  >
                    <div style={{ height: "220px" }}></div>
                    {notice.length > 0 ? (
                      notice?.map((e) => {
                        // console.log("hhhkkkii", e?.notice);
                        return (
                          <a
                            class="line_break my-2"
                            id="line_break"
                            // href={e?.notice}
                            style={{
                              color: "#0072E5",
                              textDecoration: "underline",
                              lineBreak: "anywhere",
                              display: "block",
                              whiteSpace: "break-spaces",
                              fontSize: "14px",
                              // marginTop: "20px",
                            }}
                            target="_blank"
                          >
                            {e}
                          </a>
                        );
                      })
                    ) : (
                      <Box>
                        <Skeleton
                          variant="rectangular"
                          width={210}
                          height={118}
                        />
                        <Skeleton animation="wave" />
                        {/* <Skeleton animation={false} /> */}
                      </Box>
                    )}
                  </Marquee>
                ) : (
                  <div className="text-center m-auto">
                    <h6>No Notice Found</h6>
                  </div>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
